module.exports = "<jhi-jumbotron>\n    <h1>Rattacher un dossier à mon compte</h1>\n</jhi-jumbotron>\n<div class=\"container\">\n    <jhi-breadcrumb [steps]=\"steps\"></jhi-breadcrumb>\n    <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/rattachement/rattachement.component.html
// module id = 819
// module chunks = 0